import { render, staticRenderFns } from "./RecipeComments.vue?vue&type=template&id=f4458200"
import script from "./RecipeComments.vue?vue&type=script&lang=js"
export * from "./RecipeComments.vue?vue&type=script&lang=js"
import style0 from "./RecipeComments.vue?vue&type=style&index=0&id=f4458200&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports